import React, { useEffect, useState } from 'react'

import StudentCardData from './StudentCardData'
import StudentCardAnalytics from './StudentCardAnalytics'
import { studentData } from '../../../constants/StudentAnalyticsConstants'
import StudentInfoModal from '../../modals/StudentInfoModal'
import { useQuery } from '../../../utils/util'
import { getStudentAnalyticsInfo } from '../../../server/server'

function StudentCard({ student, setStudent, setSelectedClass }) {
    const [studentInfoOpen, setStudentInfoOpen] = useState(false)

    const [loading, setLoading] = useState(true)
    const query = useQuery()
    const studentId = query.get('id')

    useEffect(() => {
        loadStudent(studentId)
    }, [studentId])

    const loadStudent = async (studentId) => {
        const resp = await getStudentAnalyticsInfo(studentId)
        if (resp.status === 200) {
            setStudent(resp.data)
            setLoading(false)
        }
    }

    const openStudentInfoModal = () => {
        setStudentInfoOpen(true)
    }

    const closeStudentInfoModal = () => {
        setStudentInfoOpen(false)
    }

    return (
        <div className="min-w-[408px] max-w-[408px] h-fit bg-white rounded-[24px] ">
            <StudentCardData loading={loading} student={student} onClassChange={setSelectedClass} />
            <StudentCardAnalytics openStudentInfoModal={openStudentInfoModal} studentId={studentId} student={student} />
            {!!student?.id && (
                <StudentInfoModal
                    studentInfoOpen={studentInfoOpen}
                    closeStudentInfo={closeStudentInfoModal}
                    student={student}
                    currentClass={student['classes'][0]}
                    reloadStudentsList={() => {}}
                    updateClassStudents={() => loadStudent(studentId)}
                />
            )}
        </div>
    )
}

export default StudentCard
